import { render, staticRenderFns } from "./crypto-commodity.vue?vue&type=template&id=2a7d00ae"
import script from "./crypto-commodity.vue?vue&type=script&lang=js"
export * from "./crypto-commodity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports